<template>
    <div class="page1">
        <!-- page1 内部选择器隐藏，改由 home 顶部选择 -->
        <Row class="listTop">
            <Col span="7">
            <div class="leftTop">
                <span class='title'><span class="title-gradient">温湿度数据分析</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <div class="left1">
                    <chart1 :pondsid="selectedGreenhouseId" :company-id="selectedCompanyId" :greenhouse-id="selectedGreenhouseId" ref='chart1' style="margin-top: 25px;"></chart1>
                </div>
                <div class="left2">
                    <chart2 ref="chart2" :pondsid="selectedGreenhouseId" :company-id="selectedCompanyId" :greenhouse-id="selectedGreenhouseId" style="width: 100%;"></chart2>
                </div>
            </div>
            </Col>
            <Col span="10" class="center-col">
            <div class="rightTop-00">
                <center ref="chart3" :pondsid="selectedGreenhouseId" :company-id="selectedCompanyId" :greenhouse-id="selectedGreenhouseId"></center>
            </div>

            </Col>
            <Col span="7">
            <div class="rightTop-1">
                <span class='title'><span class="title-gradient">木耳种植基本信息</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <baseMessage ref="chart4" :pondsid="selectedGreenhouseId"></baseMessage>
            </div>


            <div class="rightTop-2">
                <span class='title'><span class="title-gradient">设备控制模块</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <div class="rightTop-list">
                    <dynamicControl ref="dynamicControl" :pondsid="selectedGreenhouseId" :company-id="selectedCompanyId" :greenhouse-id="selectedGreenhouseId"></dynamicControl>
                </div>
            </div>

            </Col>
        </Row>
        <Row class="listBottom">
            <Col span='8' style="padding-right: 10px;">
            <div class="content">
                <span class="title"><span class="title-gradient">CO<sub>2</sub>浓度变化曲线</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <div class="behavior">
                <chart6 style="height: 100%" ref="chart6" :select-range-date="selectRangeDate" :config="configData"
                        :pondsid="selectedGreenhouseId" :company-id="selectedCompanyId" :greenhouse-id="selectedGreenhouseId"></chart6>
                </div>
            </div>
            </Col>
            <Col span='8' style="padding: 0 10px;">
            <div class="content">
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <span class="title"><span class="title-gradient">光照数值分析</span></span>
                <chart4 ref="chart7" :pondsid="selectedGreenhouseId" :company-id="selectedCompanyId" :greenhouse-id="selectedGreenhouseId" style="height: 90%"></chart4>
            </div>
            </Col>
            <Col span='8' style="padding-left: 10px;">
            <div class="content">
                <span class="title"><span class="title-gradient">传感器设备信息</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <div class="appUse">
                    <chart5 ref="chart8" :pondsid="selectedGreenhouseId" :company-id="selectedCompanyId" :greenhouse-id="selectedGreenhouseId"></chart5>
                </div>
            </div>
            </Col>
        </Row>
    </div>
</template>

<script>
    const chart1 = () => import('./components/page1/chart1');
    const chart2 = () => import('./components/page1/chart2');
    const chart4 = () => import('./components/page1/chart4');
    const chart5 = () => import('./components/page1/chart5');
    const chart6 = () => import('./components/page1/chart6');
    const baseMessage = () => import('./components/page1/baseMessage');
    const center = () => import('./components/page1/center');
    const dynamicControl = () => import('./components/page1/dynamicControl');

    export default {
        name: 'page1',
        props: {
            selectRangeDate: Array,
            value: {
                type: Number,
            }
        },
        components: {
            center,
            chart1,
            chart2,
            chart4,
            chart5,
            chart6,
            baseMessage,
            dynamicControl
        },
        data() {
            return {
                isSuperAdmin: false,
                selectedCompanyId: null,
                selectedGreenhouseId: null,
                user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
                configData: {
                    title: '',
                    color: '#fff',
                    name: ['（投喂量）', '（投喂量）'],
                    data: [
                        {
                            name: '海鲈鱼',
                            color: ['#2871ea', '#0a1b41'],
                            xdata: [],
                            ydata: []
                        },
                    ],
                },
                resizeFn: null
            }
        },
        methods: {
            handleSelectionEvent(e) {
                const { companyId, greenhouseId } = e.detail || {};
                if (companyId !== undefined) this.selectedCompanyId = companyId;
                if (greenhouseId !== undefined) this.selectedGreenhouseId = greenhouseId;
                this.refreshAll();
            },
            // 移除 page1.vue 中的 initSelection、loadCompanies、loadGreenhouses
            // 这些数据由 home.vue 统一管理，通过事件传递给 page1
            onCompanyChange(id) {
                this.selectedCompanyId = id;
                this.selectedGreenhouseId = null;
                this.refreshAll();
            },
            onGreenhouseChange(id) {
                this.selectedGreenhouseId = id;
                this.refreshAll();
            },
            refreshAll() {
                this.getFeedData();
                if (this.$refs.chart1 && this.$refs.chart1.setData) this.$refs.chart1.setData();
                if (this.$refs.chart2 && this.$refs.chart2.setData) this.$refs.chart2.setData();
                if (this.$refs.chart5 && this.$refs.chart5.setData) this.$refs.chart5.setData();
                if (this.$refs.chart6 && this.$refs.chart6.setData) this.$refs.chart6.setData();
                if (this.$refs.chart7 && this.$refs.chart7.setData) this.$refs.chart7.setData();
                if (this.$refs.chart8 && this.$refs.chart8.setData) this.$refs.chart8.setData();
                if (this.$refs.chart3 && this.$refs.chart3.loadCameraStream) this.$refs.chart3.loadCameraStream();
                if (this.$refs.dynamicControl && this.$refs.dynamicControl.setData) this.$refs.dynamicControl.setData();
            },
            getFeedData() {
                this.request.get("/api/Echart/getfeed", {
                    params: {
                        pondsid: this.value,
                        number: 10
                    }
                }).then(res => {
                    if (res.code == 200) {
                        let data = res.data;
                        this.configData.data[0].xdata = data.map(item => item.time);
                        this.configData.data[0].ydata = data.map(item => item.amount);
                    }
                })
            }
        },
        watch: {
            value() {
                this.getFeedData();
            }
        },
        mounted() {
            // 移除重复的公司/大棚数据加载，由 home.vue 统一管理
            this.getFeedData();
            window.addEventListener('page1-selection', this.handleSelectionEvent);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.resizeFn)
            window.removeEventListener('page1-selection', this.handleSelectionEvent);
        }
    }
</script>

<style lang="less">
    .page1 {
        height: 100%;
        width: 100%;
        padding: 14px 20px 20px;
        background: #03044A;
        overflow: hidden;
        position: relative;

        .listTop {
            height: 60%;

            .ivu-col {
                height: 100%;

                &.center-col {
                    padding: 0 10px;
                }

                .leftTop {
                    width: 100%;
                    height: 100%;
                    border: 1px solid #0D2451;
                    position: relative;

                    .left1 {
                        width: 100%;
                        height: 50%;
                        margin-top: 50px;
                    }

                    .left2 {
                        width: 100%;
                        height: 40%;

                    }
                }

                .rightTop-00 {
                    width: 100%;
                    height: 85%;
                    border: 1px solid #0D2451;
                    position: relative;
                    margin-top: 5%;
                }

                .rightTop-1 {
                    width: 100%;
                    height: 40%;
                    border: 1px solid #0D2451;
                    position: relative;

                }

                .rightTop-2 {
                    width: 100%;
                    margin-top: 5%;
                    height: 55%;
                    border: 1px solid #0D2451;
                    position: relative;

                    .rightTop-list {
                        margin-top: 5%;
                        width: 100%;
                        height: 90%;
                    }
                }

            }
        }

        .ivu-date-picker {
            .ivu-date-picker-panel {
                font-size: 14px; 
                color: #333; 
            }

            .ivu-date-picker-panel-body {
                font-size: 14px; 
                color: #333; 
            }

            .ivu-date-picker-panel-footer {
                font-size: 14px; 
                color: #333; 
            }
        }
    

    .listBottom {
        height: 60%;

        .ivu-col {
            height: 65%;

            .content {
                margin-top: 30px;
                height: calc(100% - 30px);
                border: 1px solid #0D2451;
                position: relative;

                .ivu-row {
                    &.topLine {
                        height: 90%;
                    }

                    &.bottomPie {
                        height: 45%;
                    }

                    .ivu-col {
                        height: 100%;

                        .charts-list {
                            height: 100%;
                            width: 50%;
                        }
                    }
                }

                .behavior {
                    width: 100%;
                    height: 100%;
                }

                .appUse {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    }
</style>
